import { Text, View } from "@react-pdf/renderer";
import { getSeverityDescription } from "../../../../utils/riskMatrix";
import { styles } from "../../ReactPdfStyles";
import { renderAsTag } from "../utils";

type IncidentConsequenceSectionTypes = {
	data: Record<string, any>;
};

export function IncidentConsequenceSection({
	data,
}: IncidentConsequenceSectionTypes) {
	const primaryConsequence = data?.primary_consequence;
	const consequences = data?.consequences;

	return (
		<View style={[styles.section, styles.tableFontSize]}>
			<Text style={styles.tableHeader}>Primary consequence</Text>

			<View style={styles.row}>
				<Text style={styles.labelCell}>Primary consequence</Text>
				<Text style={[styles.valueCell, styles.borderRight]}>
					{primaryConsequence?.consequence ?? "—"}
				</Text>
			</View>

			<View style={styles.row}>
				<Text style={styles.labelCell}>Severity</Text>
				<View style={[styles.valueCell, styles.borderRight]}>
					{primaryConsequence?.severity_level ? (
						<View
							style={{
								flexDirection: "row",
								alignItems: "flex-start",
								width: "100%",
							}}
						>
							{renderAsTag(primaryConsequence.severity_level)}
							<View style={{ flexGrow: 1, flexBasis: 0, paddingLeft: 4 }}>
								<Text wrap>
									{getSeverityDescription(
										primaryConsequence.consequence,
										primaryConsequence.severity_level
									)}
								</Text>
							</View>
						</View>
					) : (
						<Text>—</Text>
					)}
				</View>
			</View>

			{consequences && consequences.length > 0 && (
				<View style={styles.row}>
					<Text style={styles.labelCell}>Additional consequences</Text>
					<View
						style={[
							styles.valueCell,
							styles.borderRight,
							{ flexDirection: "column" },
						]}
					>
						{consequences.map((consequence: any, index: number) => (
							<View
								key={consequence?.consequence_no ?? index}
								style={{
									flexDirection: "column",
									marginBottom: 8,
								}}
							>
								<Text style={{ fontWeight: "bold" }}>
									{consequence?.consequence_no}
								</Text>
								<Text wrap style={{ marginBottom: 2 }}>
									{consequence?.consequence}
								</Text>
								{consequence?.severity_level ? (
									<View
										style={{
											flexDirection: "row",
											alignItems: "flex-start",
											width: "100%",
										}}
									>
										{renderAsTag(consequence.severity_level)}
										<View
											style={{
												flexGrow: 1,
												flexBasis: 0,
												paddingLeft: 4,
											}}
										>
											<Text wrap>
												{getSeverityDescription(
													consequence.consequence,
													consequence.severity_level
												)}
											</Text>
										</View>
									</View>
								) : (
									<Text>—</Text>
								)}
							</View>
						))}
					</View>
				</View>
			)}
		</View>
	);
}

export default IncidentConsequenceSection;
